import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getList = async (params: object) => {
  return await POST({ url: Api.getList, params, showError: false })
}
export const readNewAd = async (params: object) => {
  return await POST({ url: Api.readNewAd, params, showError: false })
}
